module.exports = __webpack_public_path__ + "static/why-choose-us-physical-therapy-west-loop-07c141bb10b883a1df76787da500133b.webp";